import React, { useContext, useEffect } from "react";
import { ControlContext } from "../../ControlContext.jsx";
import ChangeDepths from "../../Helpers/ChangeDepths.jsx";
import * as THREE from "three";

export default function Border({}) {
  const {
    borderWidth,
    borderHeight,
    printWidth,
    printHeight,
    borderOffsetX,
    borderOffsetY,
    borderMaterial,
    frameType,
    borderToneMapping,
    borderExposure,
    borderColor,
  } = useContext(ControlContext);

  const { borderDepth } = ChangeDepths();

  useEffect(() => {
    if (borderMaterial) {
      borderMaterial[0].toneMapped = true;
      borderMaterial[0].toneMapping = borderToneMapping;
      borderMaterial[0].toneMappingExposure = borderExposure;
      borderMaterial[0].envMapIntensity = 5;
      borderMaterial[0].needsUpdate = true;
    }
  }, [borderMaterial, borderToneMapping, borderExposure]);

  const receiveShadows = frameType === "Box" || frameType === "Aluminum";
  const castShadows = frameType === "Print";

  if (frameType === "Canvas") {
    return <></>;
  } else {
    return (
      <>
        <mesh
          material={borderMaterial[0]}
          receiveShadow={receiveShadows}
          castShadow={castShadows}
          position-z={borderDepth}
          position-x={0}
          position-y={0}
        >
          <shapeGeometry
            args={[
              createBorderGeometry(
                borderWidth,
                borderHeight,
                printWidth,
                printHeight,
                borderOffsetX,
                borderOffsetY
              ),
            ]}
          />
        </mesh>
      </>
    );
  }
}

function createBorderGeometry(
  borderWidth,
  borderHeight,
  printWidth,
  printHeight,
  offsetX,
  offsetY
) {
  const borderShape = new THREE.Shape();
  borderShape.moveTo(
    -printWidth / 2 - borderWidth,
    -printHeight / 2 - borderHeight
  );
  borderShape.lineTo(
    printWidth / 2 + borderWidth,
    -printHeight / 2 - borderHeight
  );
  borderShape.lineTo(
    printWidth / 2 + borderWidth,
    printHeight / 2 + borderHeight
  );
  borderShape.lineTo(
    -printWidth / 2 - borderWidth,
    printHeight / 2 + borderHeight
  );
  borderShape.lineTo(
    -printWidth / 2 - borderWidth,
    -printHeight / 2 - borderHeight
  );

  const holePath = new THREE.Path();
  holePath.moveTo(-printWidth / 2 + offsetX, -printHeight / 2 + offsetY);
  holePath.lineTo(printWidth / 2 + offsetX, -printHeight / 2 + offsetY);
  holePath.lineTo(printWidth / 2 + offsetX, printHeight / 2 + offsetY);
  holePath.lineTo(-printWidth / 2 + offsetX, printHeight / 2 + offsetY);
  holePath.closePath();

  borderShape.holes.push(holePath);

  return borderShape;
}
